exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Add some basic styling for the disabled button */\n.is-disabled[data-v-dd290f70] {\n  color: #ccc;\n  cursor: not-allowed !important;  /* Disable cursor */\n}\n", ""]);

// exports
